module.exports = __webpack_public_path__ + "media/styles/images/svg/circle-ex-gray-dark-on-red-275e3e25aa58fe44bf67bbdd57feab5e.svg";